export class TopbarButton {

  constructor(
    public label: string,
    public url: string,
    public linkLabel: string
  ) {}

}
